export var targetsInteractiveElement = function targetsInteractiveElement(event) {
  var _event$target;
  return /^(input|textarea|select)$/i.test((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.tagName);
};